import { InputStream } from './InputStream.js';
/**
 * Base64DecodeInputStream
 *
 * @author Kazuhiko Arase
 */
export class Base64DecodeInputStream extends InputStream {
    istream;
    buffer = 0;
    buflen = 0;
    constructor(istream) {
        super();
        this.istream = istream;
    }
    readByte() {
        while (this.buflen < 8) {
            const c = this.istream.readByte();
            if (c == -1) {
                if (this.buflen == 0) {
                    return -1;
                }
                throw new Error('unexpected end of file./' + this.buflen);
            }
            else if (c == '='.charCodeAt(0)) {
                this.buflen = 0;
                return -1;
            }
            else if (Base64DecodeInputStream.isWhitespace(c)) {
                // ignore if whitespace.
                continue;
            }
            this.buffer = (this.buffer << 6) | Base64DecodeInputStream.decode(c);
            this.buflen += 6;
        }
        const n = (this.buffer >>> (this.buflen - 8)) & 0xff;
        this.buflen -= 8;
        return n;
    }
    static isWhitespace(c) {
        return c == '\v'.charCodeAt(0) || c == '\t'.charCodeAt(0) || c == '\r'.charCodeAt(0) || c == '\n'.charCodeAt(0);
    }
    static decode(c) {
        if ('A'.charCodeAt(0) <= c && c <= 'Z'.charCodeAt(0)) {
            return c - 'A'.charCodeAt(0);
        }
        else if ('a'.charCodeAt(0) <= c && c <= 'z'.charCodeAt(0)) {
            return c - 'a'.charCodeAt(0) + 26;
        }
        else if ('0'.charCodeAt(0) <= c && c <= '9'.charCodeAt(0)) {
            return c - '0'.charCodeAt(0) + 52;
        }
        else if (c == '+'.charCodeAt(0)) {
            return 62;
        }
        else if (c == '/'.charCodeAt(0)) {
            return 63;
        }
        else {
            throw new Error('c:' + c);
        }
    }
}
//# sourceMappingURL=Base64DecodeInputStream.js.map